export default function a11yProps(index: number, idPrefix) {
  return {
    id: `${idPrefix}-${index}`,
    'aria-controls': `${idPrefix}panel-${index}`,
  };
}
